/**
 * Page-level block presence + deferred init helpers.
 */

export function isBlockOnPage(...names) {
  const listed = window.SOJ_BLOCKS_ON_PAGE;
  if (!Array.isArray(listed) || listed.length === 0) {
    return true;
  }
  return names.some((name) => listed.includes(name));
}

export function whenVisible(elements, callback, options = {}) {
  let list = [];
  if (typeof elements === "string") {
    list = Array.from(document.querySelectorAll(elements));
  } else if (elements instanceof Element) {
    list = [elements];
  } else {
    list = Array.from(elements || []);
  }

  if (!list.length) {
    return;
  }

  const run = () => callback(list);

  if (typeof IntersectionObserver === "undefined") {
    run();
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        io.disconnect();
        run();
      }
    },
    {
      root: null,
      rootMargin: options.rootMargin || "400px 0px",
      threshold: 0,
    },
  );

  list.forEach((el) => io.observe(el));
}
